import { SimpleGrid, Stack, useText } from "@sveabank/cc-common";
import { UspListItem } from "../../../components/bullet-list/usp-list-item";
import Hide from "../../../components/hide";
import type { ForetagarnaPackage } from "../../../types/package";
import PackageBlock from "./package-block";

type Props = {
	foretagarnaPackage?: ForetagarnaPackage;
};

const ForetagarnaPackageBlock = ({ foretagarnaPackage }: Props) => {
	const [t, texts] = useText();

	if (!foretagarnaPackage) return null;

	const text = texts.choosePackage[foretagarnaPackage.packageId];

	return (
		<PackageBlock
			heading={t(text.title)}
			headingColor="text-text-contrast"
			onboardingPackage={foretagarnaPackage}
			bgColor="bg-background-foretagarna"
			imageSrc="FORETAGARNA"
			moreAbout={t(text.moreAbout)}
		>
			<Hide to="tablet">
				<Stack component="ul" gap={4}>
					<SimpleGrid cols={2} gap={1}>
						<UspListItem text={t(text.desktop.bullet1)} />
						<UspListItem text={t(text.desktop.bullet2)} />
						<UspListItem text={t(text.desktop.bullet4)} />
						<UspListItem text={t(text.desktop.bullet5)} />
					</SimpleGrid>
				</Stack>
			</Hide>

			<Hide from="tablet">
				<Stack component="ul" gap={4}>
					<SimpleGrid cols={2} gap={1}>
						<UspListItem text={t(text.mobile.bullet1)} />
						<UspListItem text={t(text.mobile.bullet2)} />
						<UspListItem text={t(text.mobile.bullet3)} />
					</SimpleGrid>
				</Stack>
			</Hide>
		</PackageBlock>
	);
};

export default ForetagarnaPackageBlock;
